import {Camera24Icon} from "@kaltura/ds-react-icons";
import {Button} from "@kaltura/ds-react-components";
import {isMobileDevice, translate} from "@mediaspace/shared/utils";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

interface MeetingButtonProps {
    size?: "large" | "medium";
    isAdmin: boolean;
    mobileSupport: boolean;
    isNewrowSupported: boolean;
    startMeeting: () => void;
    openMeeting: () => void;
}

/**
 * kme start/join meeting button to render inside the lobby
 */
const MeetingButton = (props: MeetingButtonProps) => {
    const {isAdmin, mobileSupport, isNewrowSupported, startMeeting, openMeeting, size} = props;

    const showMobileButton = isMobileDevice && mobileSupport && isNewrowSupported;
    const buttonText = showMobileButton ? translate("Launch app session") :
        isAdmin ? translate("Start Meeting") : translate("Join Meeting");

    const sendButtonAnalytics = useButtonAnalytics();

    const onButtonClick = () => {
        const action = showMobileButton ? "Launch app" : (isAdmin ? "Start" : "Enter");
        sendButtonAnalytics(`Media Hero - ${action} session`, ButtonClickAnalyticsType.LAUNCH);
        isAdmin ? startMeeting() : openMeeting();
    }

    return (
        <Button
            color={"primary"}
            onClick={onButtonClick}
            startIcon={<Camera24Icon />}
            aria-label={buttonText}
            size={size}
        >
            {buttonText}
        </Button>
    )
}

export default MeetingButton;
